<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="args['order.no']" placeholder="placeholder.pleaseEnterOrderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="args['customer.no']" placeholder="placeholder.pleaseEnterCustomerNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="args['customer.name']" placeholder="placeholder.pleaseEnterCustomerName" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading" @cell-click="({row})=>showDetails(row)">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
        <vxe-column :title="type ==='refundable'? 'business.label.returnOperator': 'business.label.operator'" field="order.operator"/>
        <vxe-column field="customer.no" title="business.label.customerNo"/>
        <vxe-column field="customer.name" title="business.label.customerName" width="300"/>
        <vxe-column field="owner.name" title="business.label.ownerName" width="120"/>
        <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
        <vxe-column :title="type ==='refundable'? 'business.label.returnMethod': 'business.label.pickupMode'" field="pickupMode.name"/>
        <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
        <vxe-column field="order.notes" title="business.label.notes"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.review" icon="vxe-icon-check" status="primary" @click.stop="confirm(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :pageSizes="[5, 10, 15, 20]" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>
<script>
import { findAll, post } from '@/api/Api'
import api from '@/api'

export default {
  name: 'ReviewOrder',
  props: {
    type: { type: String }
  },
  data() {
    return {
      loading: false,
      data: [],
      changeToDispatch: this.type === 'appointed' || this.type === 'oneStep',
      args: {
        'order.no': '',
        'customer.no': '',
        'customer.name': ''
      },
      typeOptions: {
        refundable: {
          refundable: true,
          orderStatus: 43
        },
        shortable: {
          refundable: false,
          orderStatus: 43,
          shortable: true
        }
      },
      page: 1,
      size: 5,
      contentSize: 0
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = {
        ...this.typeOptions[this.type],
        ...this.args
      }
      findAll('dispatchOrderListFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
          if (this.data.length > 0) {
            this.$refs.table.setRadioRow(this.data[0])
            this.$refs.table.setCurrentRow(this.data[0])
            this.showDetails(this.data[0])
          } else {
            this.clearDetails()
          }
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.args = {
        'order.no': '',
        'customer.no': '',
        'customer.name': ''
      }
      this.refresh()
    },
    confirm(row) {
      this.loading = true
      post(api.reviewConfirm, { type: 'orderConfirmer' }, { 'order.id': row.order.id }).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.refresh()
        }
      }).finally(() => this.loading = false)
    },
    showDetails(row) {
      this.$emit('showDetails', row)
    },
    clearDetails() {
      this.$emit('clearDetails')
    }
  }
}
</script>